import { Typography } from "@mui/material"

type Props = {}

const YouInfoTitle = (props: Props) => {
  return <Typography variant="h5">Your Info</Typography>
}

export default YouInfoTitle
